/* eslint-disable quotes */
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    loadComponent: async () => import('./blog.component').then(m => m.BlogComponent),
    data: {
      title: 'Pool and Hot Tub Care Blog and Learning Center'
    }
  },
  // {
  //   path: 'pool-care-101',
  //   component: PoolCareInfoComponent,
  //   data: {
  //     title: 'Pool Care 101'
  //   }
  // },
  {
    path: '5-tips-for-getting-rid-of-hot-tub-foam',
    loadComponent: async () => import('./five-tips-for-getting-rid-of-hot-tub-foam/five-tips-for-getting-rid-of-hot-tub-foam.component').then(m => m.FiveTipsForGettingRidOfHotTubFoamComponent),
    data: {
      title: '5 Tips to Get Rid of Hot Tub Foam'
    }
  },
  {
    path: '5-simple-steps-to-properly-maintain-your-pool',
    loadComponent: async () => import('./five-simple-steps-to-properly-maintain-your-pool/five-simple-steps-to-properly-maintain-your-pool.component').then(m => m.FiveSimpleStepsToProperlyMaintainYourPoolComponent),
    data: {
      title: '5 Simple Steps to Properly Maintain Your Pool'
    }
  },
  {
    path: 'bioguard-three-step-program',
    loadComponent: async () => import('./bioguard-three-step-program/bioguard-three-step-program.component').then(m => m.BioguardThreeStepProgramComponent),
    data: {
      title: 'Keep Your Pool Sparkling Clear with the BioGuard 3-Step Program'
    }
  },
  {
    path: 'cold-plunge-with-sirona-spa-care',
    loadComponent: async () => import('./cold-plunge-with-sirona-spa-care/cold-plunge-with-sirona-spa-care.component').then(m => m.ColdPlungeWithSironaSpaCareComponent),
    data: {
      title: 'How to Properly Maintain Your Cold Plunge with Sirona Spa Care'
    }
  },
  {
    path: 'freshwater-salt-system-cartridges-now-available',
    loadComponent: async () => import('./freshwater-salt-system-cartridges-now-available/freshwater-salt-system-cartridges-now-available.component').then(m => m.FreshwaterSaltSystemCartridgesNowAvailableComponent),
    data: {
      title: 'Freshwater Salt System Cartridges Now Available'
    }
  },
  {
    path: 'get-your-hot-tub-ready-for-winter',
    loadComponent: async () => import('./get-your-hot-tub-ready-for-winter/get-your-hot-tub-ready-for-winter.component').then(m => m.GetYourHotTubReadyForWinterComponent),
    data: {
      title: 'Essential Hot Tub Chemical Care Tips for Fall & Winter'
    }
  },
  {
    path: 'how-to-purge-hot-tub-with-ahh-some',
    loadComponent: async () => import('./how-to-purge-hot-tub-with-ahh-some/how-to-purge-hot-tub-with-ahh-some.component').then(m => m.HowToPurgeHotTubWithAhhSomeComponent),
    data: {
      title: 'How to Purge Your Hot Tub with Ahh-Some'
    }
  },
  {
    path: 'sironas-simply-three-step-water-program',
    loadComponent: async () => import('./sironas-simply-three-step-water-program/sironas-simply-three-step-water-program.component').then(m => m.SironasSimplyThreeStepWaterProgramComponent),
    data: {
      title: `Sirona Simply's 3 Step Water Care Program`
    }
  },
  {
    path: 'my-pool-hut-opening-announcement',
    loadComponent: async () => import('./my-pool-hut-opening-announcement/my-pool-hut-opening-announcement.component').then(m => m.MyPoolHutOpeningAnnouncementComponent),
    data: {
      title: `My Pool Hut Opening Announcement`
    }
  },
  {
    path: 'winterize-with-bioguard',
    loadComponent: async () => import('./winterize-with-bioguard/winterize-with-bioguard.component').then(m => m.WinterizeWithBioguardComponent),
    data: {
      title: `How to Winterize and Close Your Pool`
    }
  },
  {
    path: 'how-to-open-pool-for-season',
    loadComponent: async () => import('./how-to-open-pool-for-season/how-to-open-pool-for-season.component').then(m => m.HowToOpenPoolForSeasonComponent),
    data: {
      title: `How to Open Your Pool for the Season`
    }
  },
  {
    path: 'why-poolife-phospate-remover-transforms-maintenance',
    loadComponent: async () => import('./why-poolife-phospate-remover-transforms-maintenance/why-poolife-phospate-remover-transforms-maintenance.component').then(m => m.WhyPoolifePhospateRemoverTransformsMaintenanceComponent),
    data: {
      title: `Why Poolife Phosphate Remover Transforms Your Pool Maintenance`
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogRoutingModule { }
